import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  List,
  PlanChatTitle,
  PlanChatWrapper,
  Title,
  Wrapper,
  Text,
} from "../PlanPicker/styles";
import ShopInsurance from "../../assets/images/shop-insurance.png";
// import { HeirsDashboardUrl } from "../../utils/constants";
// import { Mixpanel } from "../../Mixpanel";

const Index = () => {
  const handleChatWithUs = (e) => {
    e.preventDefault();
    window.fcWidget.open({});
  };

  return (
    <Wrapper id="travel">
      <div className="ant-table" id="ant-table">
        <div id="d-fixed" />
        <div id="product-table">
          <table id="table">
            <tbody className="ant-table-tbody">
              <tr>
                <th colspan="4" className="ant-table-cell">
                  <Title>
                    <h3
                      style={{
                        color: "#ff0000",
                        padding: "16px",
                        textAlign: "center",
                      }}
                    >
                      Geographical Scope of Coverage
                    </h3>{" "}
                  </Title>
                </th>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text bold s12>
                    Worldwide
                  </Text>
                </td>
                <td colspan="3" className="ant-table-cell">
                  <Text s12>
                    Provides worldwide cover except in the country of residence.
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text bold s12>
                    Worldwide I
                  </Text>
                </td>
                <td colspan="3" className="ant-table-cell">
                  <Text s12>
                    Provides worldwide cover except in the country of residence,
                    USA, Canada, and Australia
                  </Text>
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ marginTop: "20px" }}>
            <tbody className="ant-table-tbody">
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}></td>
                <td className="ant-table-cell">
                  <Text highlight s11>
                    Pilgrimage Protection Basic
                  </Text>
                </td>
                <td className="ant-table-cell">
                  <Text highlight s11>
                    Pilgrimage Protection Plus
                  </Text>
                </td>
                <td className="ant-table-cell">
                  <Text highlight s11>
                    Pilgrimage Protection Extra
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "25%" }}>
                  <Text s11>Cost</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>From NGN 2,545.34</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>From NGN 3,271.87</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>From NGN 3,632.66</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "25%" }}>
                  <Text s11>Destination</Text>
                </td>
                <td className="ant-table-cell" colspan="3">
                  <Text s11>
                    Worldwide (all regions except those holy places located in
                    Europe)
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "25%" }}>
                  <Text s11>Pricing</Text>
                </td>
                <td className="ant-table-cell" colspan="3">
                  <Text s11>
                    <a
                      href="/travel-pilgrimage-pricelist"
                      style={{ width: "130px", padding: "4px 16px" }}
                    >
                      See Price List
                    </a>
                  </Text>
                </td>
              </tr>
              <tr>
                <td
                  className="ant-table-cell"
                  style={{ textAlign: "center" }}
                  colspan="4"
                >
                  <Text highlight>Coverage for You</Text>
                </td>
              </tr>
              <tr>
                <td
                  className="ant-table-cell"
                  style={{ width: "40%" }}
                  colspan="4"
                >
                  <Text bold s11>
                    Medical & Emergency Assistance
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>
                    Medical expenses and hospitalisation abroad including
                    COVID-19
                  </Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $15,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $25,000</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>
                    Compulsory quarantine in case the insured is tested positive
                    for COVID-19
                  </Text>
                </td>
                <td className="ant-table-cell" colspan="3">
                  <Text s11>Up to $85/day (maximum 14 days)</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>Emergency Medical Evacuation</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $15,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $15,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $15,000</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>Repatriation of Mortal Remains</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $5,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $15,000</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" colspan="4">
                  <Text bold s11>
                    Baggage
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>
                    Loss of passport, driving license, or national identity card
                    abroad
                  </Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $125</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $250</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $375</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>
                    Compensation for in-flight loss of checked-in baggage
                  </Text>
                  <List s11>
                    <li>Per bag</li>
                    <li>Per item</li>
                  </List>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $250</Text>
                  <List s11>
                    <li>Up to $125</li>
                    <li>Up to $10</li>
                  </List>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $500</Text>
                  <List s11>
                    <li>Up to $250</li>
                    <li>Up to $25</li>
                  </List>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $750</Text>
                  <List>
                    <li>Up to $375</li>
                    <li>Up to $75</li>
                  </List>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" colspan="4">
                  <Text bold s11>
                    Personal Assistance Services
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>International Assistance</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Covered</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Covered</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Covered</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" colspan="4">
                  <Text bold s11>
                    Personal Accident in Means of Public Transport
                  </Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>
                    Accidental death occurred in means of public transport
                  </Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>Personal disability</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>% of principal sum as per scale</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>% of principal sum as per scale</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>% of principal sum as per scale</Text>
                </td>
              </tr>
              <tr>
                <td className="ant-table-cell" style={{ width: "40%" }}>
                  <Text s11>Permanent total disability</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,000</Text>
                </td>
                <td className="ant-table-cell">
                  <Text s11>Up to $10,00</Text>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colspan="4">
                  <Text s12>
                    <a
                      href="https://forms.heirsinsurance.com/travel-insurance/"
                      target="blank"
                      style={{
                        background: "#ff0000",
                        color: "#fff",
                        display: "inline-block",
                        padding: "8px",
                        borderRadius: "5px",
                        width: "200px",
                        height: "auto",
                      }}
                    >
                      Get Started
                    </a>
                  </Text>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Wrapper>
  );
};

export default Index;
